import React, { useEffect, useRef, useState } from "react";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import ChatTab from "./ChatTab";
import "../style.scss";
import { Skeleton, Tabs } from "antd";
import Search from "antd/es/input/Search";
import debounce from "lodash/debounce";
import { CloseOutlined } from "@ant-design/icons";
import { useChatMessageStore } from "../store";
import { httpClientCron } from "../../../api/module/httpClientCron";
import SearchUserList from "../SearchUsersList";
import GroupChatTab from "../GroupChatTab";
import OnlineUsers from "../OnlineUsers";
import CohortStudents from "../CohortStudents";

export default function LastChatMessages({ userProfile }) {
  const queryClient = useQueryClient();
  const [text, setText] = useState("");
  const [users, setUsers] = useState([]);
  const [isSearching, setIsSearching] = useState(false);
  const chatMessageStore = useChatMessageStore();

  const { data: lastMessages, isLoading } = useQuery({
    queryKey: ["LAST_CHAT_MESSAGES", userProfile.id],
    queryFn: async () => {
      const { data } = await httpClientCron.get(`private/last-chat-messages`);

      return data;
    },
    enabled: !!userProfile.id,
  });

  const updateSeenMutation = useMutation({
    mutationFn: async ({ receiverId, type = "individual", groupChatId }) => {

      if (type === "individual") {
        await httpClientCron.patch(`private/chat-message/seen/${receiverId}`);
      } else {
        await httpClientCron.patch(`private/chat-message/group-chat/${groupChatId}/seen`)
      }
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ["LAST_CHAT_MESSAGES", userProfile.id] });
      await queryClient.invalidateQueries({ queryKey: ["GROUP_CHAT_LAST_MESSAGE"] });
      await queryClient.invalidateQueries({ queryKey: ["TOTAL_CHAT_UNREAD_COUNT"] });
    },
  });

  const onFieldClear = (event) => {
    event.stopPropagation();
    setUsers([]);
    setText("");
    setIsSearching(false);
  };

  const onChange = (event) => {
    const value = event.currentTarget.value;

    setText(value);

    if (!value) {
      setIsSearching(false);
      setUsers([]);
    }
  };

  const getUsersMutation = useMutation({
    mutationFn: async ({ slug, text }) => {
      const { data } = await httpClientCron.post(`private/chat-message/users`, { text });

      return data;
    },
    onSuccess: (data) => {
      const seen = new Set();

      const deduplicatedUsers = data.filter(item => {
        if (seen.has(item.UserId)) return false;
        seen.add(item.UserId);
        return true;
      })

      setUsers(deduplicatedUsers);
    },
  });

  const onSearch = (value) => {

    if (!value) return;

    setIsSearching(true);

    getUsersMutation.mutate({
      text: value,
    });
  };

  const searchUserList = (
    <SearchUserList
      isLoading={getUsersMutation.isLoading}
      users={users}
      setText={setText}
      setIsSearching={setIsSearching}
      setUsers={setUsers}
      updateSeenMutation={updateSeenMutation}
    />
  );

  const doesExist = ["lourencelinao13@gmail.com", "enrique@hackinghr.io", "lourencelinao13+gang@gmail.com", "jessa@hackinghr.io", "morecontrol64@gmail.com", "danielle@hackinghr.io"].includes(userProfile.email)

  const items = [
    {
      key: "1",
      label: "Chats",
      children: (
        <div style={{
          overflowY: "auto",
          height: "calc(100vh - 325px)",
        }}>
          <ChatTab
            isLoading={isLoading}
            lastMessages={lastMessages}
            userProfile={userProfile}
            updateSeenMutation={updateSeenMutation}
          />
          {/*{searchUserList}*/}
        </div>
      ),
    },
    // {
    //   key: "2",
    //   label: "Group",
    //   children: (
    //     <div style={{
    //       overflowY: "auto",
    //       height: "calc(100vh - 325px)",
    //     }}>
    //       {!isSearching && (
    //         <GroupChatTab userProfile={userProfile} updateSeenMutation={updateSeenMutation} />
    //       )}
    //       {searchUserList}
    //     </div>
    //   ),
    // },
    // (doesExist ? {
    //   key: "3",
    //   label: `Online (${Array.from(new Map(chatMessageStore.onlineUsers.map(item => [item.userId, item])).values()).filter(item => item.userId !== userProfile.id).length})`,
    //   children: (
    //     <div style={{
    //       overflowY: "auto",
    //       height: "calc(100vh - 325px)",
    //     }}>
    //       {!isSearching && (
    //         <OnlineUsers
    //           userProfile={userProfile}
    //           setText={setText}
    //           setIsSearching={setIsSearching}
    //           setUsers={setUsers}
    //           isLoading={getUsersMutation.isLoading}
    //         />
    //       )}
    //       {searchUserList}
    //     </div>
    //   ),
    // }: null),
    {
      key: "4",
      label: `Cohort Students`,
      // label: `Online (${Array.from(new Map(chatMessageStore.onlineUsers.map(item => [item.userId, item])).values()).filter(item => item.userId !== userProfile.id).length})`,
      children: (
        <div style={{
          overflowY: "auto",
          height: "calc(100vh - 325px)",
        }}>
          <Search
            style={{ width: "100%", padding: "0 16px", marginBottom: "1rem" }}
            placeholder="Search user"
            onSearch={debounce(onSearch, 300)}
            allowClear={{ clearIcon: <CloseOutlined onClick={onFieldClear} /> }}
            enterButton="Search"
            size="large"
            value={text}
            onChange={onChange}
          />
          {!isSearching && (
            <CohortStudents
              userProfile={userProfile}
              setText={setText}
              setIsSearching={setIsSearching}
              setUsers={setUsers}
              isLoading={getUsersMutation.isLoading}
              updateSeenMutation={updateSeenMutation}
            />
          )}
          {searchUserList}
        </div>
      ),
    },
  ];

  return (
    <div className="chat-message-container">
      <div>
        {!doesExist ? (
          <GroupChatTab userProfile={userProfile} updateSeenMutation={updateSeenMutation} />
        ): (
          <div className="chatbox">
            <Tabs defaultActiveKey="1" items={items} />
          </div>
        )}
      </div>
    </div>
  );
}